/// <reference path="../specifyEmployee/specifyEmployeeBase.section.ts" />

module Meevo.Plugins.Register {
    "use strict";

    export class SplitCommissionSection extends Meevo.Plugins.Register.SpecifyEmployeeBaseSection {
        private selectedSaleLine: Model.SaleLine;

        splitCommissions: any;
        employee2Criteria: any;
        public employee1: Model.Employee;
        public splitCommission1: number = 0;
        public employee2: Model.Employee;
        public splitCommission2: number = 0;

        private showEmployeeSelection: boolean;

        protected FULL_COMMISSION: any = {
            displayName: "Full Commission",
            firstEmployeeValue: 1,
            id: "00000000-0000-0000-0000-000000000000",
            secondEmployeeValue: 1
        };

        get $translate() { return this.registerContext.$translate; }

        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(registerContext, false, "specifyEmployee", Register.RegisterSectionCatTypeEnum.Other, RegisterSectionTypeEnum.SplitCommission);
        }

        reset() {
            this.showEmployeeSelection = true;
            this.template = "specifyEmployee";
            this.selectedSaleLine = null;
            this.splitCommission1 = 0;
            this.splitCommission2 = 0;
        }

        edit(saleLine: Model.SaleLine) {
            this.selectedSaleLine = saleLine;
            this.employee1 = this.selectedSaleLine.employee;
            this.getEmployees([this.employee1.id]).then(() => {
                // see if the filter matches the House, if not, do not add
                if (this.registerContext.isHouseEmployeeMatched(this.filter) && !this.registerContext.isEmployeeHouseEmployee(saleLine.employee)) {
                    this.employees.splice(0, 0, this.registerContext.HouseEmployee);
                }
                this.registerContext.setLoggedInEmployee(this.employees);
            });
            this.employee2Criteria = { showEmployeesOnly: true, allowSales: true, excludeIdList: [saleLine.employeeId] };
        }

        cancelSplitCommission() {
            this.registerContext.selectSection(this.registerContext.previouslySelectedSection.sectionType, false);
        }

        goBack() {
            if (this.showEmployeeSelection) {
                this.registerContext.selectSection(this.registerContext.previouslySelectedSection.sectionType, false);
            }
            else {
                this.showEmployeeSelection = true;
                this.template = "specifyEmployee";
            }
        }

        getSplitCommissions() {
            return this.dataService.customMethodData("api/settings/compensation/splitcommissionsettings", "GET", {}).then((response: any) => {
                if (response && response.data) {
                    this.splitCommissions = response.data.splitCommissionSettingsList || [];
                    this.splitCommissions.splice(0, 0, this.FULL_COMMISSION);
                }
            });
        }

        add(employee) {
            if (this.registerContext.isEmployeeHouseEmployee(employee)) {
                this.modalService
                    .confirmHandler(this.$translate.instant("MESSAGE_SPLIT_COMMISSION_WITH_HOUSE", { employee: this.registerContext.HouseEmployee.displayName }))
                    .then((response: boolean) => {
                        if (response) {
                            this.postAdd(employee);
                        } 
                    });
            } else {
                this.postAdd(employee);
            }
        }

        postAdd(employee) {
            this.employee2 = employee;
            this.getSplitCommissions().then(() => {
                this.showEmployeeSelection = false;
                this.template = "splitCommission";
            });
        }

        selectSplitCommission(splitCommission) {
            if(!this.isFullCommissionForHouseEmployee(splitCommission)){
                this.splitCommission1 = splitCommission.firstEmployeeValue;
                this.splitCommission2 = splitCommission.secondEmployeeValue;
            }
        }

        applySplitCommission(isValid) {
            if (!isValid || (this.splitCommission1 == 0 && this.splitCommission2 == 0)) {
                return;
            }

            this.selectedSaleLine.employee = this.employee1;
            this.selectedSaleLine.employeeId = (this.employee1.id)?this.employee1.id:Guid.empty.toString();
            this.selectedSaleLine.secondEmployee = this.employee2;
            this.selectedSaleLine.secondEmployeeId = this.employee2.id;
            this.selectedSaleLine.employeeSplitCommission = this.splitCommission1;
            this.selectedSaleLine.secondEmployeeSplitCommission = this.splitCommission2;

            this.registerContext.resetPrepaidTipMinimums(this.registerContext.sale);

            this.registerContext.recalculateTip().then(() => {
                this.registerContext.selectSection(RegisterSectionTypeEnum.Services);
            });
        }

        splitCommission1Changed() {
            this.splitCommission2 = this.registerContext.subtractNormalizedNumbers(1, this.splitCommission1);
        }

        splitCommission2Changed() {
            this.splitCommission1 = this.registerContext.subtractNormalizedNumbers(1, this.splitCommission2);
        }

        employeeChanged(employee) {
            if (this.registerContext.isEmployeeHouseEmployee(employee)) {
                this.modalService.confirmHandler(this.$translate.instant("MESSAGE_SPLIT_COMMISSION_WITH_HOUSE", { employee: this.registerContext.HouseEmployee.displayName}))
                    .then((response: boolean) => {
                        if (!response) {
                            this.employee2 = null;
                        } else {
                            if (this.splitCommission1 == 1 && this.splitCommission2 == 1) {
                                this.splitCommission2 = 0;
                            }
                        }
                    });
            }
        }

        isFullCommissionForHouseEmployee(splitCommission) {
            return (splitCommission.id == this.FULL_COMMISSION.id &&
            (this.registerContext.isEmployeeHouseEmployee(this.employee1) ||
                this.registerContext.isEmployeeHouseEmployee(this.employee2)));
        }
    }
}